import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { QuoteInformation, StudySubject } from 'queries';
import { ChangeEvent, useCallback } from 'react';
import { CheckboxBlockField, TooltipText } from 'components';
import { SetupCheckboxItemContainer } from '../../components/SetupCheckboxItemContainer';

export const StudySubjectSection = () => {
  const { t } = useTranslation();

  const { values, setFieldValue, resetForm } =
    useFormikContext<Partial<QuoteInformation>>();

  const source = values.source;
  const onStudySubjectChangeToB2B = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const studySubject = e.currentTarget.value;
      resetForm();
      setFieldValue('source', source);
      setFieldValue('studySubject', studySubject);
    },
    [source, resetForm, setFieldValue],
  );

  return (
    <SetupCheckboxItemContainer>
      <TooltipText
        title={t('studySetup.generalSetup.studySubject.consumersTooltip')}
      >
        <CheckboxBlockField
          label={t('studySetup.generalSetup.studySubject.consumers')}
          type="radio"
          variant="green"
          name="studySubject"
          value={StudySubject.B2C}
          trackingName="Study Subject"
        />
      </TooltipText>
      <TooltipText
        title={t('studySetup.generalSetup.studySubject.professionalsTooltip')}
      >
        <CheckboxBlockField
          label={t('studySetup.generalSetup.studySubject.professionals')}
          type="radio"
          variant="green"
          name="studySubject"
          value={StudySubject.B2B}
          onChange={onStudySubjectChangeToB2B}
          trackingName="Study Subject"
        />
      </TooltipText>
    </SetupCheckboxItemContainer>
  );
};
